import { LangCode } from "@/lib/gql/__generated__/graphql";

const LANG_CODE = {
	[LangCode.Default]: "日本語",
	[LangCode.En]: "英語",
} as const;

export function langCodeToJapanese(langCode: LangCode) {
	return LANG_CODE[langCode];
}
